import { render } from "./DonateView.vue?vue&type=template&id=1b93fab7&scoped=true"
const script = {}

import "./DonateView.vue?vue&type=style&index=0&id=1b93fab7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b93fab7"]])

export default __exports__